export default "__VITE_ASSET__g8evk7s___"